import { Tooltip, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PropsWithChildren } from "react";

interface DisabledAreaProps
  extends PropsWithChildren<Omit<TooltipProps, "children">> {
  disabled?: boolean;
}

const DisabledContainer = styled("div")({
  cursor: "not-allowed",
  position: "relative",
  zIndex: 0,
});

const OverlayArea = styled("div")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 100,
});

export const DisabledArea = (props: DisabledAreaProps) => {
  const { disabled, children, ...rest } = props;

  if (!disabled) {
    return children;
  }

  return (
    <Tooltip arrow placement="right" {...rest}>
      <DisabledContainer>
        <OverlayArea />
        {children}
      </DisabledContainer>
    </Tooltip>
  );
};
